import { Backgrounds, Spacings, Theme } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  mainContent: {
    width: '100%',
    position: 'relative',
  },
  errorContent: {
    position: 'absolute',
    top: Spacings.s32,
    left: Spacings.s8,
    right: Spacings.s8,
    zIndex: 2,
  },
  resultErrorContent: {
    position: 'absolute',
    top: '50px',
    left: Spacings.s0,
    right: Spacings.s0,
    zIndex: 2,
  },
  closeIcon: {
    cursor: 'pointer',
    fill: 'var(--texts-base)',
  },
  inspireMe: {
    height: 35,
    width: 35,
  },
  tabs: {
    position: 'sticky',
    top: '0',
    backgroundColor: Backgrounds.tint1,
  },
  tabPanel: {
    paddingRight: Spacings.s10,
  },
  button: {
    padding: `${Spacings.s6} ${Spacings.s12}`,
  },
  scrollbox: {
    padding: 0,
  },
  text: {
    lineHeight: '32px',
  },
});

export default useStyles;
